import React from 'react'

import classNames from 'classnames'
import { useLocation } from 'react-router-dom'

import { useDialogStore } from '@stores/dialog.store'

interface Props {
  className: string
  onClick?: (e: React.MouseEvent) => void
  count?: number
}

const SocialIcon: React.FC<Props> = ({ className, count, onClick }) => {
  const cssClasses = classNames(
    'nf-icon text-xl',
    className,
    onClick ? 'cursor-pointer' : 'cursor-default'
  )

  const openDialog = useDialogStore((s) => s.openDialog)
  const { pathname } = useLocation()

  const onClickIcon = (e) => {
    if (onClick) {
      if (pathname.startsWith('/learnpremiumcontent')) {
        openDialog('purchase_learn')
      } else {
        onClick(e)
      }
    }
  }

  // it's okay that 0 is falsy since we don't want to show '0 favorites | 0 views'
  const countEl = count ? (
    <span className="absolute pl-1 text-gray-text dark:text-gray left-5">{count}</span>
  ) : null

  return (
    <div className="relative flex flex-row items-center">
      <button className="min-w[2rem] h-4 relative flex items-center" onClick={onClickIcon}>
        <i className={cssClasses} />
      </button>
      {countEl}
    </div>
  )
}

export default SocialIcon
